const mime = {
  cert: 'application/x-pkcs7-certificates',
  p7s: 'application/x-pkcs7-signature',
  pdf: 'application/pdf',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip: 'application/zip',
} as const;

export type Mime = typeof mime[keyof typeof mime];

export default mime;
